export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-17.d7eff415.png";